import lock from '../assets/icons/lock.svg';
import logo from '../assets/images/novus.svg';
const PageNotFound = () => {
	return (
		<div className="flex flex-col py-10 gap-40 items-center bg-white h-[100vh]">
			<img
				className="fill-rcrm-primary-blue w-[200px] h-[60px] object-fill"
				src={logo}
				alt=""
			/>
			<div className="flex flex-col text-center items-center">
				<img
					className="fill-rcrm-primary-blue w-[100px] h-[100px] object-fill"
					src={lock}
					alt=""
				/>
				<div>
					<div className="text-rcrm-primary-blue text-lg font-semibold">
						Access Denied
					</div>
					<div>You don't have permission to view this page.</div>
				</div>
			</div>
		</div>
	);
};

export default PageNotFound;
